import React from "react";
import { Progress, InfiniteScroll, InputFactory } from "nq-component";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../usecases/object";
import CardView from "../../../../components/common/CardView";
import BaseListPage from "../../../../base/BaseListPage";
import withRouter from "../../../../withRouter";
import Table from "../../../../components/Table";
import {
  DialogConfirmation,
  FloatingForm,
} from "../../../../components/common/Converter";
import SpecialAwardPresenter from "./SpecialAwardPresenter";
class ListOfSpecialAward extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new SpecialAwardPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      isModalOpen: false,
      title: "",
      description: "",
      qualification: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCollectionName() {
    return "special_award";
  }
  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  showError(error, title) {
    if (error instanceof Object) {
      return this.showError(error.message, title);
    }
    if (typeof error === "string") {
      const options = {
        title: title || "Error",
        message: error,
        icon: "bi bi-x-circle",
        type: "danger",
        positiveButton: "OKAY",
        negativeButton: false,
      };
      return this.showDialog(options);
    }
  }

  async handleOpenNomination(enableBtn) {
    await this.presenter.handleOpenNomination(enableBtn);
  }

  async hanlceCloseNomi(object) {
    await this.presenter.handleCloseNomi(object);
  }

  handleNewSpecialAward() {
    this.setState({
      isModalOpen: true,
      title: "",
      description: "",
      qualification: "",
    });
  }

  inputChange = (field) => (value) => {
    this.setState({ [field]: value });
  };

  // async handleSubmit(e) {
  //   e.preventDefault();
  //   const { title, description, qualification } = this.state;
  //   const data = { title, description, qualification };
  //   try {
  //     // const submitForm = new SubmitFormBaseList();
  //     await this.presenter.Save(this.getCollectionName(), data);
  //     this.setState({ isModalOpen: false });
  //     this.showSuccess("Data Successfully saved!");
  //     this.refetchData();
  //   } catch (error) {
  //     this.showError(error.message);
  //     console.error("error: ", error);
  //   }
  // }

  async handleSubmit(e) {
    e.preventDefault();
    const { title, description, qualification, editingId } = this.state;
    const id = editingId;
    const data = { id, title, description, qualification };

    try {
      if (editingId) {
        await upsertUseCase().execute(
          this.getCollectionName(),

          data
        );
      } else {
        await this.presenter.Save(this.getCollectionName(), data);
      }

      this.setState({ isModalOpen: false, editingId: null });
      this.showSuccess("Data successfully saved!");
      this.refetchData();
    } catch (error) {
      this.showError(error.message);
      console.error("Error: ", error);
    }
  }

  async handleDeleteData(data) {
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  // edit function
  async handleEditData(id) {
    try {
      // Fetch the object data by id (you can replace this with the actual fetch logic)
      const objectData = await findObjectUseCase().execute("special_award", {
        where: { id: id },
      });

      // Update the state with the fetched data and open the modal
      this.setState({
        isModalOpen: true,
        title: objectData[0]?.title || "",
        description: objectData[0]?.description || "",
        qualification: objectData[0]?.qualification || "",
        editingId: id, // Save the id to determine if editing
      });
    } catch (error) {
      this.showError(error.message || "Failed to fetch data for editing.");
    }
  }

  async handleViewObject(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/view/${id?.id}`);
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, limit, count, current } = this.state;
    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();

    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div>
              <CardView style={{ borderRadius: 0 }}>
                <div className="d-flex align-items-center justify-content-between">
                  <h4 className="text-primary">{schema.label}</h4>
                  <button
                    className="btn btn-primary"
                    onClick={this.handleNewSpecialAward.bind(this)}
                  >
                    <i className="bi bi-plus-lg" /> New {schema.label}
                  </button>
                </div>
              </CardView>

              <Table
                objectId={this.handleDeleteData.bind(this)}
                editId={this.handleEditData.bind(this)}
                viewObject={this.handleViewObject.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                objectData={this.hanlceCloseNomi.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                specialColumn={[
                  {
                    label: <i></i>,
                    actionType: "object",
                  },
                ]}
                actionsList={[
                  {
                    label: <i></i>,
                    actionType: "common",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", "isEnable"]
                )}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
        {this.state.isModalOpen && (
          <>
            <FloatingForm width="30rem">
              <CardView style={{ padding: 0 }}>
                <h4 className="fs-6 fw-bold pt-3 ps-3">
                  Special Award Details
                </h4>
                <hr />
                <form onSubmit={(e) => this.handleSubmit(e)}>
                  <div className="w-100 pt-3" style={{ padding: "0 1.5rem" }}>
                    {["Title", "Description", "Qualification"].map(
                      (label, index) => (
                        <div key={index}>
                          <label className="mb-2">
                            {label} <span className="text-danger">*</span>
                          </label>
                          <div className="col-lg-12 mb-4">
                            <InputFactory
                              required
                              type={label === "Title" ? "String" : "Text"}
                              value={this.state[label.toLowerCase()]}
                              onChange={(value) =>
                                this.inputChange(label.toLowerCase())(value)
                              }
                            />
                          </div>
                        </div>
                      )
                    )}
                  </div>
                  <hr />
                  <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                    <button
                      className="btn btn-light"
                      onClick={() => this.setState({ isModalOpen: false })}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary"
                      type="submit"
                      // onClick={this.handleSubmit.bind(this)}
                    >
                      Save
                    </button>
                  </div>
                </form>
              </CardView>
            </FloatingForm>
          </>
        )}
      </>
    );
  }
}

export default withRouter(ListOfSpecialAward);
